// Each step has its own identifier
export enum StepId {
  HEAT_OR_COMBI = 'heatOrCombi',
  EMOBILITY_INTEREST = 'emobilityInterest',
  EMOBILITY_BUY = 'emobilityBuy',
  SOLAR_ROOF_SHAPE = 'solarRoofShape',
  SOLAR_ROOF_DIRECTION = 'solarRoofDirection',
  SOLAR_POWER_USAGE = 'solarPowerUsage',
  SOLAR_OFFER = 'solarOffer',
  HEATING_TYPE = 'heatingType',
  HEATING_USAGE = 'heatingUsage',
  HEATING_DISTRIBUTION = 'heatingDistribution',
  HEATING_CONSTRUCTION_YEAR = 'heatingConstructionYear',
  HEATING_BUILDING_TYPE = 'heatingBuildingType',
  HEATING_INTEREST = 'heatingInterest',
  COMBI_INTEREST = 'combiInterest',
  COMBI_HOUSING_SITUATION = 'combiHousingSituation',
  COMBI_INITIAL_SITUATION = 'combiInitialSituation',
  COMBI_ROOF = 'combiRoof',
  COMBI_HEATING = 'combiHeating',
  ASSISTANT_SUBMIT = 'assistantSubmit',
}

// You can optionally divide steps into groups,
// each one having its own identifier
export enum StepCategoryId {
  ROOT = 'root',
  SUBMIT = 'submit',
  EMOBILITY = 'emobility',
  SOLAR = 'solar',
  HEATING = 'heating',
  COMBI = 'combi',
}

export enum StepGroupId {}
